export default "__VITE_ASSET__BHdqsGhr__"